const VIEWS = {
    SHOW_EDIT_SLIDE_ANIMATION_SETTINGS: 'SHOW_EDIT_SLIDE_ANIMATION_SETTINGS',
    HIDE_EDIT_SLIDE_ANIMATION_SETTINGS: 'HIDE_EDIT_SLIDE_ANIMATION_SETTINGS',
    SHOW_EDIT_SLIDE_CAPTION_SETTINGS: 'SHOW_EDIT_SLIDE_CAPTION_SETTINGS',
    HIDE_EDIT_SLIDE_CAPTION_SETTINGS: 'HIDE_EDIT_SLIDE_CAPTION_SETTINGS',
    SHOW_EDIT_SLIDE_SETTINGS: 'SHOW_EDIT_SLIDE_SETTINGS',
    HIDE_EDIT_SLIDE_SETTINGS: 'HIDE_EDIT_SLIDE_SETTINGS',
    SHOW_EDIT_SLIDE_DRILLDOWNS: 'SHOW_EDIT_SLIDE_DRILLDOWNS',
    HIDE_EDIT_SLIDE_DRILLDOWNS: 'HIDE_EDIT_SLIDE_DRILLDOWNS',
    SHOW_ELEMENT_SETTINGS: 'SHOW_ELEMENT_SETTINGS',
    SHOW_LINK_SETTINGS: 'SHOW_LINK_SETTINGS',
    SHOW_LAYERS: 'SHOW_LAYERS',

}

export {VIEWS}